function initialClassName() {
    const policyContainerEl = $('.shopify-policy__container');

    if (policyContainerEl.length === 0) {
        return;
    }

    policyContainerEl.parent().addClass('policy-page');

    policyContainerEl.addClass('max-w-none p-0');

    policyContainerEl.find('.shopify-policy__body').addClass('mx-auto max-w-7xl px-4 py-8 sm:px-6 md:px-8 prose');

    policyContainerEl.find('.shopify-policy__title').addClass('terms-bg');

    policyContainerEl.find('.shopify-policy__title h1').addClass('text-[30px] lg:text-[42px] text-[#3c4196] text-center max-w-[200px] sm:max-w-full');
}

function isPolicyPage() {
    // In the future if we have more policy page use the same layout please add them into the array below
    const POLICY_PAGE_HANDLE_UI = [
        'terms-of-service',
        'privacy-policy',
        'refund-policy'
    ];
    const pathNameArr = window.location.pathname.split('/');
    const pathName = pathNameArr[pathNameArr.length - 1];

    return POLICY_PAGE_HANDLE_UI.includes(pathName);
}

$(document).ready(function () {
    if (isPolicyPage()) {
        initialClassName();
        $('.content-for-layout').show();
    }
});